import { MouseEventElement } from '../../Interfaces/HTML';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

interface Output {
  buildNavigateRoteByClickHandler: (
    url: string,
  ) => (e: MouseEventElement) => void;
}

export const useNavigateHook = (): Output => {
  const navigate = useNavigate();

  const buildNavigateRoteByClickHandler = useCallback(
    (url: string) => (e: MouseEventElement) => {
      e.preventDefault();
      navigate(url);
    },
    [navigate],
  );

  return {
    buildNavigateRoteByClickHandler,
  };
};
